import { formatRupiah } from '../../utils/printHelper';
import { invoiceAmounts } from '../../utils/invoiceAmounts';

function Row({ label, value, sign = '', tone = '', bold = false, divider = false }) {
  return (
    <div className={`flex justify-between ${divider ? 'border-t pt-1' : ''} ${bold ? 'font-bold' : ''} ${tone}`}>
      <span>{label}</span>
      <span className="font-mono">{sign}Rp {formatRupiah(value)}</span>
    </div>
  );
}

/**
 * Breakdown of an invoice's amounts, laid out in the same order as the printed
 * Voucher Pembayaran. `overrides` previews unsaved edits (see invoiceAmounts).
 */
export function InvoiceAmountSummary({ invoice, overrides, className = '', title }) {
  const a = invoiceAmounts(invoice, overrides);

  return (
    <div className={`p-4 rounded-lg border space-y-1 text-sm ${className || 'bg-slate-50 border-slate-200'}`} data-testid="invoice-amount-summary">
      {title && <p className="font-semibold mb-2">{title}</p>}
      <Row label="Subtotal Item" value={a.subtotal} />
      {a.potonganRetur > 0 && <Row label="Potongan / Retur" value={a.potonganRetur} sign="- " tone="text-orange-700" />}
      <Row label="DPP (Dasar Pengenaan Pajak)" value={a.dpp} bold divider />
      {a.hasPpn && <Row label={`PPn (${a.ppnPercentage}%)`} value={a.ppnAmount} />}
      {a.biayaAngkut > 0 && <Row label="Biaya Angkut" value={a.biayaAngkut} />}
      {a.pembulatan !== 0 && <Row label="Pembulatan" value={a.pembulatan} sign={a.pembulatan > 0 ? '+' : ''} />}
      {a.dpAmount > 0 && <Row label={`Down Payment (${invoice?.dp_number || 'DP'})`} value={a.dpAmount} sign="- " tone="text-amber-700" />}
      <Row label="Total Tagihan" value={a.totalTagihan} bold divider />
      {a.pphAmount > 0 && (
        <Row label={`Potongan PPh (${a.pphType} ${a.pphPercentage}%)`} value={a.pphAmount} sign="- " tone="text-rose-700" />
      )}
      {a.adminBank > 0 && <Row label="Admin Bank" value={a.adminBank} sign="- " tone="text-blue-700" />}
      <div className="flex justify-between font-bold text-base border-t pt-2">
        <span>Nilai Dibayarkan</span>
        <span className="font-mono text-emerald-700" data-testid="summary-nilai-dibayarkan">Rp {formatRupiah(a.nilaiDibayarkan)}</span>
      </div>
    </div>
  );
}
